import { subscribeToEvent } from '../tools/event-subscribe';

export function scrollTypeCollector(onData) {
  const data = {
    touchmove: 0,
    keydown: 0,
    scroll: 0,
  };

  let lastType,
    lastTime,
    lastRecordType,
    lastScrollTarget,
    count = 0;

  /**
     *
     * @param {Event} e
     */
  function handleType(e) {
    lastType = e.type;
    lastTime = e.timeStamp;
  }

  /**
     *
     * @param {Event} e
     */
  function handleScroll(e) {
    count++;
    const target = e.target;

    if (lastType && lastTime + 100 > e.timeStamp) {
      if (!lastScrollTarget || target != lastScrollTarget) {
        record(lastType);
      } else if (lastRecordType != lastType) {
        record(lastType);
      }
    } else {
      lastType = lastTime = null;

      if (!lastScrollTarget
        || target != lastScrollTarget
        || lastRecordType != 'scroll') {
        record('scroll');
      }
    }

    lastScrollTarget = target;
  }

  function record(type) {
    lastRecordType = type;
    data[type]++;
    onData(type);
  }

  const subscriptions = [
    subscribeToEvent(window, 'touchmove', handleType, { capture: true }),
    subscribeToEvent(window, 'keydown', handleType, { capture: true }),
    subscribeToEvent(window, 'scroll', handleScroll, { capture: true }),
  ];

  function stop() {
    subscriptions.forEach(u => u());
  }

  function toString() {
    return count ? `${data.scroll}|${data.keydown}|${data.touchmove}` : '';
  }

  return {
    data,
    toString,
    stop,
  };
}



// WEBPACK FOOTER //
// ./src/lib/collectors/scroll-type.js